import { useBreakpointsContext } from '@air/provider-media-query';

import { useIsWorkspaceAgentPanelAvailable } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useIsWorkspaceAgentPanelAvailable';
import { useWorkspaceAgentPanelCanvasOpen } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentPanelCanvasOpen';
import {
  isWorkspaceAgentPanelExpanded,
  useWorkspaceAgentPanelStore,
} from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { useURLClipIdSelector } from '~/hooks/useURLClipIdSelector';

/**
 * Shared signals for composer behavior while a clip route is open and the agent panel is
 * expanded (docked or float — not minimized). Not a React context provider.
 */
export const useWorkspaceAgentExpandedAssetView = () => {
  const clipId = useURLClipIdSelector();
  const { isWorkspaceAgentPanelAvailable } = useIsWorkspaceAgentPanelAvailable();
  const { canvasOpen } = useWorkspaceAgentPanelCanvasOpen();
  const { isAboveMediumScreen } = useBreakpointsContext();
  const dock = useWorkspaceAgentPanelStore((state) => state.dock);
  const assetViewOpen = Boolean(clipId);
  const isAgentPanelExpanded = isWorkspaceAgentPanelExpanded({ dock });
  const isExpandedAssetViewModalSession = assetViewOpen && isAgentPanelExpanded;
  const retainExpandedAssetViewComposerSession = isExpandedAssetViewModalSession && isAboveMediumScreen && !canvasOpen;

  return {
    assetViewOpen,
    clipId,
    isAgentPanelExpanded,
    isExpandedAssetViewComposerActive: isWorkspaceAgentPanelAvailable && assetViewOpen && isAgentPanelExpanded,
    isExpandedAssetViewModalSession,
    isWorkspaceAgentPanelAvailable,
    retainExpandedAssetViewComposerSession,
  };
};
